import { useEffect, useState } from 'react';
import { VisuallyHidden } from '@mantine/core';
import { onSupportAnnouncement } from './supportAnnouncer';

/**
 * Пауза между очисткой области и новым текстом: тот же текст ещё раз (второе сообщение того же специалиста, повтор
 * запроса) меняет DOM и звучит снова; объявления за это время звучат вместе, а не затирают друг друга.
 */
const DELAY = 100;

/** Постоянная live-область объявлений поддержки (`announceSupport`): смонтирована до появления плашек. */
export default function SupportLiveRegion() {
    const [text, setText] = useState('');
    useEffect(() => {
        let pending: string[] = [];
        let timer: ReturnType<typeof setTimeout> | undefined;
        const off = onSupportAnnouncement((next) => {
            if (!next || pending.includes(next)) return;
            pending.push(next);
            if (timer) return;
            setText('');
            timer = setTimeout(() => {
                timer = undefined;
                setText(pending.join('. '));
                pending = [];
            }, DELAY);
        });
        return () => {
            off();
            clearTimeout(timer);
        };
    }, []);
    return (
        <VisuallyHidden role="status" aria-live="polite" data-testid="support-live-region">
            {text}
        </VisuallyHidden>
    );
}
